import Vue from 'vue'
import Pluralize from './pluralize'

Vue.filter('pluralize', Pluralize)
